import { Null, Number, Record, Static, String } from 'runtypes';

export const AutomaticUserStateRunType = Record({
	iconCls: String,
	id: Number,
	instanceName: String,
	latitude: Number.Or(Null),
	longitude: Number.Or(Null),
	name: String.Or(Null),
	radius: Number.Or(Null),
	schedule: String,
});

export type AutomaticUserState = Static<typeof AutomaticUserStateRunType>;
